
    <span *ngIf="ellipsisText" [reTooltip]="fullText" [placement]="placement">{{ellipsisText}}...</span> <span *ngIf="!html && !ellipsisText">{{fullText}}</span> <span *ngIf="html && !ellipsisText" [innerHTML]="fullText"></span>
  